import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText } from 'lucide-react';

const TermsOfService = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen pt-20 bg-gray-50 dark:bg-[#0a0e17] transition-colors duration-300">
            {/* Header */}
            <div className="bg-white dark:bg-[#111621] border-b border-gray-100 dark:border-gray-800 py-12">
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                    <Link to="/" className="inline-flex items-center text-primary-600 dark:text-primary-400 hover:text-primary-700 font-medium mb-6">
                        <ArrowLeft className="w-4 h-4 mr-2" /> Back to Home
                    </Link>
                    <div className="flex items-center space-x-3 mb-4">
                        <FileText className="w-8 h-8 text-primary-500" />
                        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Terms of Business</h1>
                    </div>
                    <p className="text-gray-600 dark:text-gray-400">
                        Effective Date: December 7, 2025
                    </p>
                </div>
            </div>

            {/* Content */}
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="prose prose-lg dark:prose-invert max-w-none text-gray-600 dark:text-gray-300 space-y-8">

                    <p className="lead text-lg">
                        These Terms of Business ("Terms") govern the provision of Quality Engineering consultancy and software services by IronGate Software Limited ("the Company," "we," or "us") to you ("the Client").
                    </p>

                    <section>
                        <h3>1. Interpretation</h3>
                        <p>
                            <b>1.1</b> "Services" means the software development, quality assurance, consultancy, and testing services provided by IronGate Software Limited.<br />
                            <b>1.2</b> "Deliverables" means any software, documentation, reports, or materials produced by us for you under a specific Statement of Work (SOW).
                        </p>
                    </section>

                    <section>
                        <h3>2. Engagement and Services</h3>
                        <p>
                            <b>2.1</b> These Terms apply to all engagements unless a separate Master Services Agreement (MSA) enters into force between the parties.<br />
                            <b>2.2</b> We shall provide the Services with reasonable skill and care, in accordance with the professional standards of the Irish software industry.<br />
                            <b>2.3</b> Timescales provided are estimates only. While we endeavor to meet all deadlines, time shall not be of the essence unless expressly agreed in writing.
                        </p>
                    </section>

                    <section>
                        <h3>3. Intellectual Property Rights (IPR)</h3>
                        <p>
                            <b>3.1 Client IP:</b> You explicitly retain all rights to your pre-existing code, data, and business processes involved in the project.<br />
                            <b>3.2 Deliverables IP:</b> Upon full payment of fees, we assign to you all Intellectual Property Rights in the custom Deliverables created specifically for you.<br />
                            <b>3.3 Company Background IP:</b> We retain all rights to our pre-existing tools, libraries, methodologies, and frameworks ("Background IP"). We grant you a non-exclusive, perpetual, royalty-free license to use such Background IP solely as necessary to utilize the Deliverables.
                        </p>
                    </section>

                    <section>
                        <h3>4. Confidentiality</h3>
                        <p>
                            <b>4.1</b> Both parties agree to maintain the confidentiality of any proprietary information ("Confidential Information") disclosed during the engagement.<br />
                            <b>4.2</b> This obligation shall not apply to information that is in the public domain, independently developed, or required to be disclosed by law or court order.
                        </p>
                    </section>

                    <section>
                        <h3>5. Fees and Payment</h3>
                        <p>
                            <b>5.1</b> Fees will be set out in the relevant Statement of Work or Quote.<br />
                            <b>5.2</b> Unless otherwise agreed, invoices are payable within 30 days of the invoice date.<br />
                            <b>5.3</b> Late payments may incur interest under the European Communities (Late Payment in Commercial Transactions) Regulations 2012.
                        </p>
                    </section>

                    <section>
                        <h3>6. Limitation of Liability</h3>
                        <p>
                            <b>6.1</b> Nothing in these Terms limits liability for death or personal injury caused by negligence, fraud, or any liability that cannot be excluded by Irish law.<br />
                            <b>6.2</b> To the maximum extent permitted by law, IronGate Software Limited shall not be liable for any indirect, special, or consequential loss (including loss of profit, data, or business opportunities).<br />
                            <b>6.3</b> Our total aggregate liability arising under or in connection with these Terms shall be limited to the total fees paid by the Client to us in the 12 months preceding the claim.
                        </p>
                    </section>

                    <section>
                        <h3>7. Termination</h3>
                        <p>
                            <b>7.1</b> Either party may terminate an engagement by giving 30 days' written notice, subject to payment for all work done up to the termination date.<br />
                            <b>7.2</b> We may terminate immediately if you fail to pay undisputed invoices or commit a material breach of these Terms.
                        </p>
                    </section>

                    <section>
                        <h3>8. Governing Law and Jurisdiction</h3>
                        <p>
                            These Terms and any dispute or claim arising out of or in connection with them shall be governed by and construed in accordance with the laws of <b>Ireland</b>.
                            The courts of Ireland shall have exclusive jurisdiction to settle any dispute or claim.
                        </p>
                    </section>

                    <section>
                        <h3>9. Contact</h3>
                        <p>
                            For any legal notices or queries regarding these terms, please contact:<br />
                            <b>IronGate Software LTD</b><br />
                            Email: contact@irongate.ie
                        </p>
                    </section>

                </div>
            </div>
        </div>
    );
};

export default TermsOfService;
